import { Box, Divider, Flex, Text } from "@mantine/core";

/**
 * @param {string} cat - 카테고리
 * @param {string} val - 값
 * @param {boolean} isLast - 마지막 요소 여부
 * @param {React.ReactNode} children - 자식 요소
 * @param {string} label - 레이블
 * @param {string} value - 값
 * @returns {React.ReactNode}
 */
export default function ListRow({ cat, val, isLast = false, children, label, value }) {
  return (
    <>
      <Flex justify="space-between" my="xs" align="center">
        <Text size="sm" color="dimmed" style={{ minWidth: "fit-content" }}>
          {cat || label}
        </Text>
        {val && (
          <Text size="sm" fw={700} ta="right">
            {val}
          </Text>
        )}
        {value && (
          <Text size="sm" fw={700} ta="right">
            {value}
          </Text>
        )}
        {children}
      </Flex>
      {!isLast && <Divider />}
    </>
  );
}
